import React from "react";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute } from "../_metronic/layout";
import { shallowEqual, useSelector } from "react-redux";
import { DashboardPage } from "./pages/DashboardPage";
import AdminsPage from "./modules/ContentManager/admins/AdminsPage";
import EditAdminsPage from "./modules/ContentManager/admins/EditAdminsPage";
import TextsPage from "./modules/ContentManager/texts/TextsPage";
import EditTextsPage from "./modules/ContentManager/texts/EditTextsPage";
import LanguagesPage from "./modules/ContentManager/languages/LanguagesPage";
import EditLanguagesPage from "./modules/ContentManager/languages/EditLanguagesPage";
import PaisesPage from "./modules/ContentManager/paises/PaisesPage";
import EditPaisesPage from "./modules/ContentManager/paises/EditPaisesPage";
import ProvinciasPage from "./modules/ContentManager/provincias/ProvinciasPage";
import EditProvinciasPage from "./modules/ContentManager/provincias/EditProvinciasPage";
import LocalidadesPage from "./modules/ContentManager/localidades/LocalidadesPage";
import EditLocalidadesPage from "./modules/ContentManager/localidades/EditLocalidadesPage";
import PeticionesPage from "./modules/ContentManager/peticiones/PeticionesPage";
import LogsPage from "./modules/ContentManager/logs/LogsPage";
import EditModalidadesPage from "./modules/ContentManager/modalidad/EditModalidadesPage";
import ModalidadesPage from "./modules/ContentManager/modalidad/ModalidadesPage";
import EditConfiguracionesPage from "./modules/ContentManager/configuracion/EditConfiguracionPage";
import YearsPage from "./modules/ContentManager/year/YearsPage";
import EditYearsPage from "./modules/ContentManager/year/EditYearsPage";

export default function BasePage() {
  const user = useSelector((store) => store.authentication?.user, shallowEqual);
  const isAdmin = user || user?.role !== "admin";

  return (
    <Switch>
      {/* Redirect from root URL to /dashboard. */}
      <Redirect exact from="/" to="/dashboard" />
      <ContentRoute path="/dashboard" component={DashboardPage} />

      {/* USERS */}
      {/* Administrators */}
      <ContentRoute from="/admins" component={AdminsPage} />
      <ContentRoute from="/edit-admin/:id?" component={EditAdminsPage} />

      {/* Peticiones */}
      <ContentRoute from="/peticiones" component={PeticionesPage} />

      {/* Logs de errores */}
      <ContentRoute from="/logs" component={LogsPage} />

      {/* MISCELLANY */}
      {/* Modalidades */}
      <ContentRoute
        from="/modalidades"
        component={!isAdmin ? DashboardPage : ModalidadesPage}
      />
      <ContentRoute
        from="/configuracion/:id"
        component={!isAdmin ? DashboardPage : EditConfiguracionesPage}
      />
      <ContentRoute
        from="/edit-modalidad/:id?"
        component={!isAdmin ? DashboardPage : EditModalidadesPage}
      />
      {/* Languages */}
      <ContentRoute
        from="/languages"
        component={!isAdmin ? DashboardPage : LanguagesPage}
      />
      <ContentRoute
        from="/edit-language/:id?"
        component={!isAdmin ? DashboardPage : EditLanguagesPage}
      />
      {/* Languages */}
      <ContentRoute
        from="/years"
        component={!isAdmin ? DashboardPage : YearsPage}
      />
      <ContentRoute
        from="/edit-year/:id?"
        component={!isAdmin ? DashboardPage : EditYearsPage}
      />
      {/* Texts */}
      <ContentRoute
        from="/texts"
        component={!isAdmin ? DashboardPage : TextsPage}
      />
      <ContentRoute
        from="/edit-text/:id"
        component={!isAdmin ? DashboardPage : EditTextsPage}
      />

      {/* Paises */}
      <ContentRoute from="/paises" component={PaisesPage} />
      <ContentRoute from="/edit-pais/:id?" component={EditPaisesPage} />

      {/* Provincias */}
      <ContentRoute from="/provincias" component={ProvinciasPage} />
      <ContentRoute
        from="/edit-provincia/:id?"
        component={EditProvinciasPage}
      />

      {/* Localidades */}
      <ContentRoute from="/localidades" component={LocalidadesPage} />
      <ContentRoute
        from="/edit-localidad/:id?"
        component={EditLocalidadesPage}
      />

      <Redirect to="/error" />
    </Switch>
  );
}
